class StockAlert extends HTMLElement {
  connectedCallback() {
    const json = this.querySelector('[data-stock-json]');
    this.message = this.querySelector('.stock-alert-message');

    if (!json || !this.message) return;

    this.stockData = JSON.parse(json.textContent);

    this.update();

    this.watchVariantInput();
  }

  getVariantInput() {
    return document.querySelector('form[action*="/cart/add"] [name="id"]');
  }

  getCurrentVariantId() {
    const input = this.getVariantInput();
    return input ? String(input.value) : null;
  }

  watchVariantInput() {
    const input = this.getVariantInput();

    if (!input) return;

    let lastValue = input.value;

    const checkForChange = () => {
      const currentValue = input.value;

      if (currentValue !== lastValue) {
        lastValue = currentValue;
        this.update();
      }
    };

    document.addEventListener('click', () => {
      setTimeout(checkForChange, 0);
      setTimeout(checkForChange, 100);
      setTimeout(checkForChange, 300);
    });

    document.addEventListener('change', () => {
      setTimeout(checkForChange, 0);
      setTimeout(checkForChange, 100);
      setTimeout(checkForChange, 300);
    });
  }

  update() {
    const variantId = this.getCurrentVariantId();

    if (!variantId || this.stockData[variantId] === undefined) return;

    const available = this.stockData[variantId];

    this.message.innerHTML = available
      ? this.inStockHTML()
      : this.outOfStockHTML();
  }

  inStockHTML() {
    return `
      <div style="width: fit-content; padding: 6px 10px; background: #FDF4EE; border-radius: 8px; outline: 1px #1da500 solid; outline-offset: -1px; display: inline-flex; align-items: center; gap: 8px;">
        <div style="width: 16px; height: 16px; border-radius: 9999px; border: 1px #1da500 solid; display: flex;">
          <div style="width: 10px; height: 10px; background: #1da500; border-radius: 9999px; margin:auto;"></div>
        </div>
        <div style="color: #1da500; font-size: 12px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.96px;">
          IN STOCK
        </div>
      </div>
    `;
  }

  outOfStockHTML() {
    return `
      <div style="width: fit-content; padding: 6px 10px; background: #FDF4EE; border-radius: 8px; outline: 1px #ff002a solid; outline-offset: -1px; display: inline-flex; align-items: center; gap: 8px;">
        <div style="width: 16px; height: 16px; border-radius: 9999px; border: 1px #ff002a solid; display: flex;">
          <div style="width: 10px; height: 10px; background: #ff002a; border-radius: 9999px; margin:auto;"></div>
        </div>
        <div style="color: #ff002a; font-size: 12px; font-family: Montserrat; font-weight: 400; letter-spacing: 0.96px;">
          OUT OF STOCK
        </div>
      </div>
    `;
  }
}

if (!customElements.get('stock-alert')) {
  customElements.define('stock-alert', StockAlert);
}